import apiClient from "@/shared/api/apiClient4";

export const getServiceListChains = async (params) => {
  try {
    const { data } = await apiClient.get("/chains/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getServiceListChains failed", e);
  }
};

export const getServiceListChain = async (id) => {
  try {
    const { data } = await apiClient.get("/chains/" + id);
    return data;
  } catch (e) {
    console.error("getServiceListChain failed", e);
  }
};

export const createServiceChain = async (params) => {
  const result = await apiClient.post(`/chains/create/`, {
    ...params,
  });
  return result.data;
};

export const updateChainStep = async (chains_id, step_id, params) => {
  const { data } = await apiClient.put(
    `/chains/${chains_id}/steps/${step_id}/`,
    {
      ...params,
    }
  );
  return data;
};

export const addServiceChainStep = async (chains_id, params) => {
  const result = await apiClient.post(`/chains/${chains_id}/steps/create/`, {
    ...params,
  });
  return result.data;
};

export const removeServiceChainStep = async (chains_id, params) => {
  const result = await apiClient.delete(
    `/chains/${chains_id}/steps/${params.step_id}/`
  );
  return result.status;
};

export const getServiceChainsStepList = async (chains_id) => {
  try {
    const { data } = await apiClient.get(`/chains/${chains_id}/steps/`);
    return data;
  } catch (e) {
    console.error("getServiceChainsStepList failed", e);
  }
};
